var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWebforms = function SvgWebforms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Webforms_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Webforms_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.602 4.8a3.2 3.2 0 0 1 3.2-3.2h22.4a3.2 3.2 0 0 1 3.2 3.2v16a3.2 3.2 0 0 1-3.2 3.2h-22.4a3.2 3.2 0 0 1-3.2-3.2v-16ZM8.002 30.4h16M16.002 24.001v6.4M11.201 12.8h9.6",
    stroke: "#14161A",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Webforms_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B7BFC8",
    d: "M.002 0h32v32h-32z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Webforms_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export { SvgWebforms as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyNDI3XzUwOTc0MCkiPgo8bWFzayBpZD0ibWFzazBfMTI0MjdfNTA5NzQwIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiPgo8cGF0aCBkPSJNMS42MDE1NiA0LjgwMDU4QzEuNjAxNTYgMy4wMzMyNyAzLjAzNDI1IDEuNjAwNTkgNC44MDE1NiAxLjYwMDU5SDI3LjIwMTZDMjguOTY4OSAxLjYwMDU5IDMwLjQwMTYgMy4wMzMyNyAzMC40MDE2IDQuODAwNTlWMjAuODAwNkMzMC40MDE2IDIyLjU2NzkgMjguOTY4OSAyNC4wMDA2IDI3LjIwMTYgMjQuMDAwNkg0LjgwMTU2QzMuMDM0MjUgMjQuMDAwNiAxLjYwMTU2IDIyLjU2NzkgMS42MDE1NiAyMC44MDA2VjQuODAwNThaIiBzdHJva2U9IiMxNDE2MUEiIHN0cm9rZS13aWR0aD0iMi40IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguMDAxOTUgMzAuNDAwNEgyNC4wMDIiIHN0cm9rZT0iIzE0MTYxQSIgc3Ryb2tlLXdpZHRoPSIyLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTYuMDAyIDI0LjAwMVYzMC40MDEiIHN0cm9rZT0iIzE0MTYxQSIgc3Ryb2tlLXdpZHRoPSIyLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTEuMjAxMiAxMi44MDA4SDIwLjgwMTIiIHN0cm9rZT0iIzE0MTYxQSIgc3Ryb2tlLXdpZHRoPSIyLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMTI0MjdfNTA5NzQwKSI+CjxyZWN0IHg9IjAuMDAxOTUzMTIiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgZmlsbD0iI0I3QkZDOCIvPgo8L2c+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTI0MjdfNTA5NzQwIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";